import { useState, useEffect, useContext, useReducer, useMemo } from 'react';
import { useTitle } from 'react-use';

import log from 'loglevel';

import {useSiteStorage, siteFunctionReducer, ACTIONS} from './utils/site-storage';

import RecipeContext from './utils/recipe-context';
import {RECIPES, findIDBySlug} from './recipes/recipe-list';
import RecipeContainer from './recipes/recipe-container';

import SitePlanContext from './utils/siteplan-context';

import {BoundBox} from './utils/mapping-functions';
import {HeightMap} from './utils/topography';

import {Layout} from './utils/layout';
import Notes from './components/notes';

const FullApp = props => {
  const [currentRecipeID, changeRecipe] = useState(findIDBySlug(window.location.hash.substr(1)));

  const onHashChange = e => {
    changeRecipe(findIDBySlug(window.location.hash.substr(1)));
  };
  window.addEventListener('hashchange', onHashChange, false);

  const [allSites, allSitesDispatch] = useSiteStorage();

  const currentSite = allSites.all[allSites.current];

  const boundBox = useMemo(() => {
    return BoundBox.createFromMarkers([...currentSite.poiMarkers.map(item=>item.latLng), ...currentSite.sitePlanCoords]);
  }, [currentSite.poiMarkers, currentSite.sitePlanCoords]);

  const heightMap = useMemo(() => {
    return (currentSite.heightMapData && currentSite.heightMapData.boundBox) ? new HeightMap(currentSite.heightMapData) : null;
  }, [currentSite.heightMapData]);

  const updatePOIMarkers = poiMarkers => {
    allSitesDispatch({
      type:ACTIONS.UPDATE_CONTENT,
      payload:{
        ...currentSite,
        poiMarkers:poiMarkers
      }
    });
  }

  const updateSitePlanCoords = sitePlanCoords => {
    allSitesDispatch({
      type:ACTIONS.UPDATE_CONTENT,
      payload:{
        ...currentSite,
        sitePlanCoords:sitePlanCoords
      }
    });
  }

  useTitle([RECIPES[currentRecipeID].name, currentSite.meta.title, props.docTitle].join(' - '));

  return(
    <SitePlanContext.Provider value={{
      allSites:allSites,
      dispatch:allSitesDispatch,
      currentSite:currentSite,

      sitePlanCoords:currentSite.sitePlanCoords,
      updateSitePlanCoords:updateSitePlanCoords,
      poiMarkers:currentSite.poiMarkers,
      updatePOIMarkers:updatePOIMarkers,
      boundBox: boundBox,
      heightMap:heightMap
    }}>
      <RecipeContext.Provider value={{
        currentRecipeID: currentRecipeID,
        currentRecipe: RECIPES[currentRecipeID],
        changeRecipe: changeRecipe
      }}>
        <Layout.GridX>
          <Layout.SideBar/>
          <Layout.MainBody>
            <RecipeContainer />
            <Layout.Footer/>
          </Layout.MainBody>
          <Notes/>
        </Layout.GridX>
      </RecipeContext.Provider>
    </SitePlanContext.Provider>
  );

}

ReactDOM.render(
  <FullApp docTitle={document.title} />,
  document.getElementById('full-app')
);
